import { WithThemeProps } from "@rjsf/core";

import Templates from "../Templates";
import Widgets from "../Widgets";

const Theme: WithThemeProps = {
  templates: Templates,
  widgets: Widgets,
};

export default Theme;
